import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
const commonmix = {
    computed: {
        ...mapState([
            'progress',
            'loginInfo',
            'isShowLeftMenu',
            'modals',
            'isShowSmallModal',
            'smallModalView',
            'modalTransitionName',
            'leftMenuModals',
            'leftMenuTransitionName',
            'refreshMemberInfo',
            'alertMessage',
            'isShowAlert',
            'centerInfo',
            'noRouterReload',
            'isLeftMenuAnimationOn',
            'modalInstance',
            'isShowToast',
            'isShowToastVer2',
            'toastStrVer2',
            'toastStr'
        ]),
        ...mapGetters({

        }),
    },
    methods : {
        ...mapMutations({
            showProgress : 'showProgress',
            setLoginInfo : 'setLoginInfo',
            logout : 'logout',
            toggleLeftMenu : 'toggleLeftMenu',
            addModal : 'addModal',
            closeLastModal : 'closeLastModal',
            changeLastModal : 'changeLastModal',
            closeModalAll : 'closeModalAll',
            changeModalTransition : 'changeModalTransition',
            addLeftMenuModal : 'addLeftMenuModal',
            clearLeftModalUntil : 'clearLeftModalUntil',
            changeLeftMenuTransition:  'changeLeftMenuTransition',
            closeLastLeftMneuModal : 'closeLastLeftMneuModal',
            setRefreshMemberInfo : 'setRefreshMemberInfo',
            showAlert : 'showAlert',
            hideAlert : 'hideAlert',
            setCenterInfo : 'setCenterInfo',
            toggleRouterReload : 'toggleRouterReload',
            setModalInstance : 'setModalInstance',
            showToast : 'showToast',
            showToastVer2 : 'showToastVer2'
        }),
        ...mapActions({

        }),

    }
};

export default commonmix;